import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {ExamFormSavePage} from './exam-form-save.page';
import {
    CreateUpdateDefaultPagePageModule
} from '../../../../core/page/create-update-default-page/create-update-default-page.module';
import {DefaultAppPageModule} from '../../../../../components/common/defaut-application-page/default-app-page.module';
import {LoadingModule} from '../../../../../components/common/loading/loading.module';
import {FormFormSaveModule} from '../../../../form/form/api/component/form-form-save/form-form-save.component';
import {CardModule} from '../../../../core/component/card/card.module';
import {
    FormDefinitionFormSelectFilterModule
} from '../../../../form/definition/form/api/component/form-definition-form-select-filter/form-definition-form-select-filter.component';
import {ActionBarButtonModule} from '../../../../core/component/action-bar-button/action-bar-button.module';
import {ButtonModule} from '../../../../core/component/button/button.module';
import {FormFieldModule} from '../../../../core/component/form-field/form-field.module';
import {
    FormDefinitionFieldSearchByLabelModule
} from '../../../../form/definition/field/api/component/form-definition-field-search-by-label/form-definition-field-search-by-label.module';
import {CommentMenuModule} from '../../../../core/component/comment/comment-menu/comment-menu.component';
import {SummaryModule} from '../../../../core/component/summary/summary.module';
import {
    CommentSummaryFieldModule
} from '../../../../core/component/comment/comment-summary-field/comment-summary-field.component';
import {
    FormDefinitionFieldSelectFilterModule
} from '../../../../form/definition/field/api/component/form-definition-field-select-filter/form-definition-field-select-filter.module';
import {DialogModule} from "../../../../common/dialog/dialog.module";
import {CreateUpdateDefaultModule} from "../../../../core/component/create-update-default/create-update-default.module";
import {StickyContainerModule} from "../../../../core/component/sticky-container/sticky-container.module";
import {
    MedicalToolSetSelectComponent
} from "../../../../medical/sterilization/toolset/api/component/medical-toolset-select/medical-toolset-select.component";
import {
    MedicalToolsetSelectManyComponent
} from "../../../../medical/sterilization/toolset/api/component/medical-toolset-select-many/medical-toolset-select-many.component";
import {CardV2Component} from "../../../../core/component/card-v2/card-v2.component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        CreateUpdateDefaultPagePageModule,
        FormFormSaveModule,
        DefaultAppPageModule,
        LoadingModule,
        CardModule,
        FormDefinitionFormSelectFilterModule,
        ActionBarButtonModule,
        ButtonModule,
        FormFieldModule,
        FormDefinitionFieldSearchByLabelModule,
        CommentMenuModule,
        SummaryModule,
        CommentSummaryFieldModule,
        FormDefinitionFieldSelectFilterModule,
        DialogModule,
        CreateUpdateDefaultModule,
        StickyContainerModule,
        MedicalToolSetSelectComponent,
        MedicalToolsetSelectManyComponent,
        CardV2Component,

    ],
    declarations: [ExamFormSavePage],
})
export class ExamFormSaveModule {
}
